import React, { useState } from 'react';
import { Box, Container, Typography, Grid, Card, CardMedia, Modal, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import leadCert from './assets/lead_cert.jpeg';
import accCert from './assets/acc_cert.png';

const certificates = [
  {
    id: 1,
    title: 'Leadership & Life Coaching Certification',
    image: leadCert,
    alt: 'Leadership & Life Coaching Certification'
  },
  {
    id: 2,
    title: 'ACC Credential',
    image: accCert,
    alt: 'ACC Credential from ICF'
  }
];

function CertificationsSection() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [selectedCert, setSelectedCert] = useState(null);

  const handleOpen = (cert) => {
    setSelectedCert(cert);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box 
      id="certifications"
      sx={{ 
        py: { xs: 6, md: 8 },
        bgcolor: 'background.paper',
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography 
            variant="h3" 
            component="h2"
            sx={{ 
              color: 'primary.main',
              mb: 2,
              fontWeight: 700
            }}
          >
            Certifications
          </Typography>
          <Typography 
            variant="h6" 
            color="text.secondary"
            sx={{
              maxWidth: '700px',
              mx: 'auto',
              mb: 4
            }}
          >
            Professional accreditations and qualifications that demonstrate expertise in coaching methodologies
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center" alignItems="stretch">
          {certificates.map((cert) => (
            <Grid item xs={12} sm={8} md={6} lg={5} key={cert.id}>
              <Card 
                elevation={3} 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: theme.shadows[8]
                  }
                }}
              >
                <Box 
                  onClick={() => handleOpen(cert)}
                  sx={{ 
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    p: 2,
                    backgroundColor: '#f8f8f8',
                    minHeight: '400px',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#f0f0f0',
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    image={cert.image}
                    alt={cert.alt}
                    sx={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '400px',
                      objectFit: 'contain',
                      margin: '0 auto',
                      display: 'block'
                    }}
                  />
                </Box>
                <Box sx={{ p: 2, textAlign: 'center' }}>
                  <Typography variant="h6" component="h3" color="text.primary">
                    {cert.title}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Modal for larger certificate view */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="certificate-modal"
        aria-describedby="certificate-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
          outline: 'none'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            maxWidth: '90%',
            maxHeight: '90vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 2,
            borderRadius: 1,
            outline: 'none',
            overflow: 'auto'
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'text.primary',
              zIndex: 1,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedCert && (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="h6" component="h3" gutterBottom>
                {selectedCert.title}
              </Typography>
              <img
                src={selectedCert.image}
                alt={selectedCert.alt}
                style={{
                  maxWidth: '100%',
                  maxHeight: 'calc(90vh - 120px)',
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto'
                }}
              />
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  );
}

export default CertificationsSection;
